import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import BannerFormService from '../services/BannerFormService';
import BannerForm from './BannerForm';

class BannerFormContainer extends React.Component {
  static propTypes = {
    bannerId: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.bannerId) {
      BannerFormService.load(this.props.bannerId);
    }
    BannerFormService.init();
  }

  render() {
    return (
      <BannerForm
        onChange={BannerFormService.handleChange}
        onSubmit={BannerFormService.handleSubmit}
        onReset={BannerFormService.handleReset}
        values={BannerFormService.form.getValues()}
        submitting={BannerFormService.submit.fetching}
        errors={BannerFormService.form.errors}
      />
    );
  }
}

export default observer(BannerFormContainer);
